<script setup>
import { defineProps, ref } from "vue";
import { formatDateRange } from "@/utils/date";
import LocationsList from "@/components/frontend/LocationsList.vue";
import Modal from "@/components/frontend/ui/Modal.vue";

const props = defineProps({
  locations: {
    type: Array,
    required: true,
  },
});

const location = ref(null);

</script>

<template>
  <div class="container-xl p-0">
    <LocationsList
      :locations="locations"
      @selectLocation="location = $event"
    ></LocationsList>

    <Modal
      v-if="location"
      title="Select a date"
      size="lg"
      :show="!! location"
      @hidePrevented="location = null"
      @hide="location = null">
      <template #header>
        <div class="modal-header">
          <div>
            <h4 class="modal-title">{{ location.name }}</h4>
            <p class="mb-0 text-muted">
              {{ location.address }} -
              <span class="text-uppercase">{{ location.country_name }}</span>
            </p>
          </div>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
      </template>
      <div v-for="stage in location?.stages" class="mb-3">
        <div>
          <h5>{{stage.name}}</h5>
          <p>{{ formatDateRange(stage.start_at, stage.end_at) }}</p>
        </div>
        <a :href="stage.urls.show" class="btn btn-primary">{{ $t('More information') }}</a>
      </div>

    </Modal>
  </div>
</template>